import styled from 'styled-components'
import { BREAKPOINTS } from 'styles/constants'

export const FileCard = styled.div`
  cursor: pointer;
  max-width: 100%;
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  font-size: 12px;
  color: var(--p-neutral-520);
  background-color: var(--t-surface-2);
  border: 1px solid var(--t-surface-2);
  position: relative;
  border-radius: 4px;
  transition: 300ms ease-out;

  img {
    width: 100%;
    height: 120px;
    object-fit: contain;
    background-color: var(--t-surface-block);
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    &:nth-child(even) {
      margin-right: 0px;
    }
  }
`

export const FileDelete = styled.button`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--p-neutral-550);
  background: transparent;
  cursor: pointer;
  transition: 0.3s ease-out;

  &:hover {
    color: var(--p-pink-480);
  }
`
export const ButtonWrapper = styled.div`
  background-color: var(--p-neutral-250);
  display: flex;
  height: 32px;
  padding: 8px 10px 8px 0;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  z-index: 100;
  background: transparent;
  top: 5px;
  right: 5px;
`

export const FileInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 100%;
  color: var(--t-lightbox-file-info-color);
`

export const FileTitle = styled.div`
  width: 100%;
  color: var(--t-link-color);
  white-space: nowrap;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 5px;
`

export const FileImage = styled.div`
  max-width: 100%;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  object-fit: cover;

  img {
    width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`

export const FileIconWrap = styled.div`
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  background: var(--t-surface-1);
  border-radius: 8px;
`

export const FileIcon = styled.svg`
  width: 53px;
  height: 67px;
  display: block;
  color: var(--t-surface-2);
`
